import React from "react";
import wrench from "./images/icons/wrench.png";
import {
  sectionHeadingStyle,
  sectionContainerStyle,
  headingContainerStyle,
  bioStyle,
} from "./components/styles";
import { Image } from "react-bootstrap";
import SkillCardItem from "./components/SkillCard";
const Skills = () => {
  const skills = [
    { title: "Android" },
    { title: "Kotlin" },
    { title: "Frontend" },
    { title: "Java" },
    { title: "Python" },
    { title: "AI/ML" },
    { title: "LLMs" },
    { title: "ReactJS" },
    { title: "NextJS" },
    { title: "Redux" },
    { title: "Hooks" },
    { title: "Bootstrap" },
    { title: "DaisyUI" },
    { title: "Flask" },
    { title: "AWS" },
    { title: "Heroku" },
    { title: "Jetpack Compose" },
    { title: "MVVM" },
    { title: "Deep Learning" },
    { title: "Machine Learning" },
    { title: "Agile Methodologies" },
    { title: "Automated Testing" },
    { title: "JUnit" },
    { title: "NodeJS" },
    { title: ".NET" },
    { title: "Angular" },
    { title: "GraphQL" },
    { title: "Flutter" },
    { title: "C#" },
    { title: "MVP" },
    { title: "MVC" },
    { title: "Git" },
    { title: "Gitflow" },
    { title: "CI/CD" },
    { title: "Kanban" },
    { title: "Trello" },
    { title: "Dart" },
    { title: "Firebase SDK" },
    { title: "Responsive UI Design" },
    { title: "Voice Assistance" },
    { title: "Optical Head-Mounted Display" },
    { title: "Market Research" },
    { title: "Product Validation" },
    { title: "Image-Sharing Platform" },
    { title: "Mobile Social Apps" },
  ];

  return (
    <div style={sectionContainerStyle}>
      <div style={headingContainerStyle}>
        <h2 style={sectionHeadingStyle}>Skills</h2>{" "}
        <Image
          src={wrench}
          alt=""
          className="section-icon"
        />
      </div>
      <p style={bioStyle}>
        I like learning by building. These are the tools, platforms, and
        practices I have picked up through research, products, and side
        projects.
      </p>
      <div className="chip-grid">
        {skills.map((object, i) => (
          <SkillCardItem key={i} obj={object} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
